import { Drawer, type DrawerProps } from '@/components';
import type { ComponentProps, FC } from 'react';
import { ActivityForm } from './ActivityForm';

type Props = ComponentProps<typeof ActivityForm> &
  Pick<DrawerProps, 'open' | 'onClose'>;

export const ActivityFormDrawer: FC<Props> = ({
  initialValues,
  open,
  onClose,
  onSubmit,
}) => {
  return (
    <Drawer open={open} onClose={onClose} destroyOnClose>
      <ActivityForm onSubmit={onSubmit} initialValues={initialValues} />
    </Drawer>
  );
};
